"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEstimationTargetProps = void 0;
var React = _interopRequireWildcard(require("react"));
var _estimationTargetSelectorOptions = require("../../../constants/estimationTargetSelectorOptions");
var _useActions = require("./useActions");
var _reactRedux = require("react-redux");
var _selectors = require("../../../selectors");
var _analytics = require("../../../analytics");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Возвращает набор пропсов для первичного фильтра "Тип оцениваемой недвижимости"
 * */
const useEstimationTargetProps = _ref => {
  let {
    isMyHome
  } = _ref;
  const {
    setEstimationTarget,
    resetFilters
  } = (0, _useActions.useActions)();
  const {
    estimationTarget
  } = (0, _reactRedux.useSelector)(_selectors.selectFilters);

  /** Набор типов недвижимости и функция аналитики отличается для моего дома */
  const estimationOptions = isMyHome ? _estimationTargetSelectorOptions.estimationTargetMyHomeSelectorOptions : _estimationTargetSelectorOptions.estimationTargetSelectorOptions;
  const submitAnalytics = isMyHome ? _analytics.trackMyHomeEstimationTargetSelect : _analytics.trackEstimationTargetSelect;
  const onValueChange = React.useCallback(estimationTarget => {
    /** При выборе нового типа оцениваемой недвижимости, сбрасываем все предыдущие фильтры */
    resetFilters();
    setEstimationTarget({
      estimationTarget
    });
    submitAnalytics(estimationTarget);
  }, [setEstimationTarget, resetFilters]);
  return {
    values: estimationOptions,
    value: estimationTarget,
    placeholder: 'Тип недвижимости',
    onValueChange
  };
};
exports.useEstimationTargetProps = useEstimationTargetProps;